<template>
  
</template>

<script>
export default {
  data() {
    return {
      allSkuList1: [{
      "productId":2480,
      "speCode":"27162305220F4BF001",
      "productSpec":"通用属性1-值1",
      "propertyJson":"{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":158,\"PropertyValueString\":\"通用属性1-值1\"}]}"
      },
      {
      "productId":2480,
      "speCode":"27162305220F4BF002",
      "productSpec":"通用属性1-值2",
      "propertyJson":"{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":159,\"PropertyValueString\":\"通用属性1-值2\"}]}"
      },
      {
      "productId":2480,
      "speCode":"27162305220F4BF003",
      "productSpec":"通用属性1-值3",
      "propertyJson":"{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":160,\"PropertyValueString\":\"通用属性1-值3\"}]}"
      },
      {
      "productId":2480,
      "speCode":"27162305220F4BF004",
      "productSpec":"通用属性1-值4",
      "propertyJson":"{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":165,\"PropertyValueString\":\"通用属性1-值4\"}]}"
      },
      {
      "productId":2480,
      "speCode":"27162305220F4BF005",
      "productSpec":"通用属性1-值5",
      "propertyJson":"{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":166,\"PropertyValueString\":\"通用属性1-值5\"}]}"
      }],
      productList1: [{
        "id": 0,
        "propertyId": 72,
        "propertyName": "通用属性1",
        "propertyValues": [{
          "propertyValueId": 158,
          "propertyValueString": "通用属性1-值1"
        },
        {
          "propertyValueId": 159,
          "propertyValueString": "通用属性1-值2"
        },
        {
          "propertyValueId": 160,
          "propertyValueString": "通用属性1-值3"
        },
        {
          "propertyValueId": 165,
          "propertyValueString": "通用属性1-值4"
        },
        {
          "propertyValueId": 166,
          "propertyValueString": "通用属性1-值5"
        }],
      }],
      allSkuList2: [
        {
          "productId": 2482,
          "speCode": "27162305230F4BF201",
          "productSpec": "通用属性1-值1*通用属性2-值1",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":158,\"PropertyValueString\":\"通用属性1-值1\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":161,\"PropertyValueString\":\"通用属性2-值1\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF202",
          "productSpec": "通用属性1-值1*通用属性2-值2",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":158,\"PropertyValueString\":\"通用属性1-值1\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":162,\"PropertyValueString\":\"通用属性2-值2\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF203",
          "productSpec": "通用属性1-值1*通用属性2-值3",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":158,\"PropertyValueString\":\"通用属性1-值1\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":163,\"PropertyValueString\":\"通用属性2-值3\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF204",
          "productSpec": "通用属性1-值2*通用属性2-值1",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":159,\"PropertyValueString\":\"通用属性1-值2\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":161,\"PropertyValueString\":\"通用属性2-值1\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF205",
          "productSpec": "通用属性1-值2*通用属性2-值2",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":159,\"PropertyValueString\":\"通用属性1-值2\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":162,\"PropertyValueString\":\"通用属性2-值2\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF206",
          "productSpec": "通用属性1-值2*通用属性2-值3",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":159,\"PropertyValueString\":\"通用属性1-值2\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":163,\"PropertyValueString\":\"通用属性2-值3\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF207",
          "productSpec": "通用属性1-值3*通用属性2-值1",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":160,\"PropertyValueString\":\"通用属性1-值3\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":161,\"PropertyValueString\":\"通用属性2-值1\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF208",
          "productSpec": "通用属性1-值3*通用属性2-值2",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":160,\"PropertyValueString\":\"通用属性1-值3\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":162,\"PropertyValueString\":\"通用属性2-值2\"}]}"
        },
        {
          "productId": 2482,
          "speCode": "27162305230F4BF209",
          "productSpec": "通用属性1-值3*通用属性2-值3",
          "propertyJson": "{\"PropertyList\":[{\"PropertyId\":72,\"PropertyString\":\"通用属性1\",\"PropertyValueId\":160,\"PropertyValueString\":\"通用属性1-值3\"},{\"PropertyId\":73,\"PropertyString\":\"通用属性2\",\"PropertyValueId\":163,\"PropertyValueString\":\"通用属性2-值3\"}]}"
        }
      ],
      productList2: [
        {
          "propertyId": 72,
          "propertyName": "通用属性1",
          "propertyValues": [
            {
              "propertyValueId": 158,
              "propertyValueString": "通用属性1-值1"
            },
            {
              "propertyValueId": 159,
              "propertyValueString": "通用属性1-值2"
            },
            {
              "propertyValueId": 160,
              "propertyValueString": "通用属性1-值3"
            }
          ],
          "id": 0
        },
        {
          "propertyId": 73,
          "propertyName": "通用属性2",
          "propertyValues": [
            {
              "propertyValueId": 161,
              "propertyValueString": "通用属性2-值1"
            },
            {
              "propertyValueId": 162,
              "propertyValueString": "通用属性2-值2"
            },
            {
              "propertyValueId": 163,
              "propertyValueString": "通用属性2-值3"
            }
          ],
          "id": 0
        }
      ],
    }
  }
}
</script>

<style>

</style>